import { Controller } from '@hotwired/stimulus'

/**
 * Липкая строка поиска.
 * Пока исходный блок в hero видим — контент остаётся в потоке. Когда блок
 * прокручивается за верхнюю границу экрана, контент закрепляется поверх
 * страницы (стили: .sticky-search в _sticky_search.scss). Позиция относительно
 * скрываемого хедера управляется через body[data-scroll-direction] в CSS,
 * по аналогии с .page-anchors.
 */
export default class StickySearchController extends Controller {
  static targets = ['content']

  #visibleTimer = null

  connect() {
    document.addEventListener('scroll', this.#onScroll, { passive: true })
    this.#onScroll()
  }

  disconnect() {
    document.removeEventListener('scroll', this.#onScroll)
    clearTimeout(this.#visibleTimer)
    this.#setSticky(false)
  }

  #onScroll = () => {
    this.#setSticky(this.element.getBoundingClientRect().bottom < 0)
  }

  #setSticky(need) {
    if (need === this.element.classList.contains('is-sticky')) return

    clearTimeout(this.#visibleTimer)

    if (need) {
      // Фиксируем высоту обёртки, чтобы hero не схлопнулся, когда контент станет fixed
      this.element.style.minHeight = `${this.contentTarget.offsetHeight}px`
      this.element.classList.add('is-sticky')
      // Пауза перед показом, чтобы панель плавно выехала уже из закреплённого состояния
      this.#visibleTimer = setTimeout(() => {
        this.element.classList.add('is-visible')
      }, 300)
    } else {
      this.element.style.minHeight = ''
      this.element.classList.remove('is-visible', 'is-sticky')
    }
  }
}
